import { render, staticRenderFns } from "./Conference.vue?vue&type=template&id=771ef7a6&scoped=true&"
import script from "./Conference.vue?vue&type=script&lang=js&"
export * from "./Conference.vue?vue&type=script&lang=js&"
import style0 from "./Conference.vue?vue&type=style&index=0&id=771ef7a6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771ef7a6",
  null
  
)

export default component.exports